import React from 'react';
import { WorkspaceStatusPill, type WorkspaceTone } from '../workflow/WorkflowWorkspacePrimitives';

export type StatusChipTone = 'success' | 'warning' | 'error' | 'info' | 'neutral';

export interface StatusChipProps {
  label: React.ReactNode;
  tone?: StatusChipTone;
  size?: 'small' | 'medium';
  dataTestId?: string;
}

const toneMap: Record<StatusChipTone, WorkspaceTone> = {
  success: 'success',
  warning: 'warning',
  error: 'error',
  info: 'info',
  neutral: 'neutral',
};

export const StatusChip: React.FC<StatusChipProps> = ({
  label,
  tone = 'neutral',
  size = 'medium',
  dataTestId,
}) => (
  <WorkspaceStatusPill
    label={label}
    tone={toneMap[tone]}
    size={size === 'small' ? 'compact' : 'default'}
    dataTestId={dataTestId}
  />
);

export default StatusChip;
